import { Box, Divider, Typography } from '@mui/material';
import { Identifier, MatchResultPlayerStatus as ResultStatus } from '@okletsplay/core';
import { MatchResultEntity } from 'app/interfaces/entity';
import { PlayerResultScore } from 'modules/matches/components/MatchResultModal/PlayerResultScore';
import { PlayerResultStatus } from 'modules/matches/components/MatchResultModal/PlayerResultStatus';
import React, { FC, Fragment, useCallback, useMemo } from 'react';
import { useStyles } from './MatchResultStatus.styles';
import { useStyles as useScrollStyles } from 'shared/styles/ScrollBar.styles';
import classNames from 'classnames';

interface MatchResultStatusProps {
  matchResults: MatchResultEntity[];
  playerNames: Record<Identifier, string>;
}

const RESULT_STATUSES_TO_DISPLAY = [ResultStatus.Win, ResultStatus.Forfeit, ResultStatus.Tied];

export const MatchResultStatus: FC<MatchResultStatusProps> = ({ matchResults, playerNames }) => {
  const { classes } = useStyles();
  const { classes: scrollBarClasses } = useScrollStyles();

  const results = useMemo(() => {
    const filteredResults = matchResults.filter((result) =>
      RESULT_STATUSES_TO_DISPLAY.includes(result.status)
    );

    const orderedResults = filteredResults.sort((left, right) => {
      if (left.status === ResultStatus.Win) return -Infinity;

      return right.score - left.score;
    });

    return orderedResults;
  }, [matchResults]);

  const isDividerDisplayed = useCallback(
    (index) => {
      return results.length > 1 && results.length !== index + 1;
    },
    [results.length]
  );

  return (
    <Box className={classNames(classes.root, scrollBarClasses.horizontal)}>
      {results.map((result, index) => (
        <Fragment key={result.userId}>
          <Box className={classes.resultContainer}>
            <PlayerResultStatus status={result.status} />
            <PlayerResultScore score={result.score} status={result.status} />
            <Typography>{playerNames[result.userId]}</Typography>
          </Box>
          {isDividerDisplayed(index) ? <Divider orientation="vertical" flexItem /> : null}
        </Fragment>
      ))}
    </Box>
  );
};
